import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import api from 'api';
import modules from 'modules';
import { setCurrentView } from 'store';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import ErrorBoundary from 'partials/ErrorBoundary';
import Footer from 'partials/Footer';
import CookieNotice from 'partials/CookieNotice';

import Media from 'css/Media';

export class RentalPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }
    componentDidMount() {
        this.props.setCurrentView(null);
        this.preparePage();
    }

    componentDidUpdate(nextProps) {
        if(nextProps.match.path != this.props.match.path) {
            this.preparePage();
        }
    }

    preparePage() {
        window.scrollTo(0, 0);
        api.pageFetcher.getBySlug({ slug: this.props.match.path.replace('/en/', '') })
            .then(resp => {
                let page = resp.data[0];
                this.props.setCurrentView(page);
                this.setState({loading: false})
            })
    }

    render() {
        const { loading } = this.state;
        const { page } = this.props;

        if (!page || page && loading) return null;

        return (
            <Wrapper>
                <Container grid>
                    <DescriptionGridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                        rowStart={1}
                        justify="center"
                    >
                        <StyledHtml content>{page.acf.title}</StyledHtml>
                        <StyledHtml content>{page.acf.description}</StyledHtml>
                    </DescriptionGridElement>
                </Container>
                <Modules>
                    <ErrorBoundary for="Rental Page Builder">
                        {page && page.acf.modules && page.acf.modules.map((module, i) => {
                            return (
                                <div key={i} className={'module-'+module.acf_fc_layout}>
                                    {React.createElement(modules[module.acf_fc_layout], { data: module })}
                                </div>
                            )
                        })}
                    </ErrorBoundary>
                </Modules>
                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>
                <CookieNotice />
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    page: state.currentView,
});

const actions = {
    setCurrentView,
};

export default connect(mapStateToProps, actions)(withRouter(RentalPage));


const Wrapper = styled.section`
    scroll-behavior: smooth;
    width: 100%;
    padding-top: ${props => props.theme.spacing.blockS};
    
    ${ Media.greaterThan('s')`
        padding-top: 220px;
    ` }  
`

const DescriptionGridElement = styled(GridElement)`
    margin-bottom: ${props => props.theme.spacing.elementS};

    ${ Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.blockM};
    ` }
`
const StyledHtml = styled(Html)`
    text-align: center;

    h1 {
        margin-bottom: ${props => props.theme.spacing.contentXL};
        font-weight: 400;

        ${ Media.greaterThan('s')`
            margin-bottom: ${props => props.theme.spacing.elementL};
        `}
    }

    p {
        font-size: 18px;
        line-height: 27px;

        ${ Media.greaterThan('s')`
            ${props => props.theme.fonts.h5};
            line-height: 32px;
        `}
    }
`

const Modules = styled.section`
    padding-bottom: ${props => props.theme.spacing.blockXS};

    ${ Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockS};
    `}
`